import Axios from "../../../../api/axios/Axios";

const encode = (value) => encodeURIComponent(String(value ?? "").trim());

const creatorVideosEndpoint = (username) =>
  `/api/creators/${encode(username)}/videos`;

export const getCreatorVideoThumbs = (username, limit, offset) =>
  Axios.get(`${creatorVideosEndpoint(username)}/thumbs`, {
    params: {
      limit,
      offset,
    },
  });

export const getCreatorVideoData = (username, videoTag) =>
  Axios.get(`${creatorVideosEndpoint(username)}/${encode(videoTag)}/data`);

export const getCreatorVideoEditData = (username, videoTag) =>
  Axios.get(`${creatorVideosEndpoint(username)}/${encode(videoTag)}/edit`);

export const updateCreatorVideo = (username, videoTag, data) =>
  Axios.put(
    `${creatorVideosEndpoint(username)}/${encode(videoTag)}/update`,
    data,
  );

export const deleteCreatorVideo = (username, videoTag) =>
  Axios.delete(`${creatorVideosEndpoint(username)}/${encode(videoTag)}/delete`);

export const searchCreatorVideos = ({ username, searchValue, limit, offset }) =>
  Axios.get(`${creatorVideosEndpoint(username)}/search`, {
    params: {
      searchValue,
      limit,
      offset,
    },
  });

export const getCreatorVideoPlay = (username, videoTag) =>
  Axios.get(`${creatorVideosEndpoint(username)}/${encode(videoTag)}/play`);

export const searchCreatorVideoTag = (videoTag) =>
  Axios.get(`/api/creators/videos/${encode(videoTag)}/search`);
